import { formatTabCount, orderTabs } from "../order-list-utils";

const OrderTabHeader = ({ counts, setActiveTab, activeTab }) => {
  return (
    <div className="ord-tabs">
      <div className="ord-tabs-track" role="tablist">
        {orderTabs.map((tab) => {
          const selected = tab.key === activeTab;
          const count = counts?.[tab.key];

          return (
            <button
              key={tab.key}
              type="button"
              role="tab"
              aria-selected={selected}
              className={`ord-tab${selected ? " is-selected" : ""}`}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label}

              {count > 0 && (
                <span className="ord-tab-count">{formatTabCount(count)}</span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default OrderTabHeader;
